import { exhibitorMock } from './data-access-exhibitor.service.mocks';
import { postMock } from './data-access-post.service.mocks';
import { productMock } from './data-access-product.service.mocks';

export const searchCountMock = {
  all: 4,
  products: 1,
  events: 1,
  posts: 1,
  exhibitors: 1,
};

export const searchResultExhibitor = {
  type: 'EXHIBITOR',
  exhibitor: {
    id: exhibitorMock.id,
    name: exhibitorMock.name,
    image: {
      provider: 'RAW',
      resource: 'http://localhost/resource.jpg',
    },
    top_of_the_list: false,
    highlight: false,
    published_at: '0000-00-00 00:00:00',
    short_description: exhibitorMock.description,
  },
};

export const searchResultProduct = {
  type: 'PRODUCT',
  product: {
    id: <string>productMock.id,
    name: productMock.name,
    image: {
      provider: 'RAW',
      resource: 'http://localhost/resource.jpg',
    },
    top_of_the_list: false,
    highlight: false,
    published_at: '0000-00-00 00:00:00',
    short_description: exhibitorMock.description,
    exhibitor_id: exhibitorMock.id,
    exhibitor_name: exhibitorMock.name,
  },
};

export const searchResultEvent = {
  type: 'EVENT',
  event: {
    id: '1',
    name: 'Lorem Ipsum',
    image: {
      provider: 'RAW',
      resource: 'http://localhost/resource.jpg',
    },
    top_of_the_list: false,
    highlight: false,
    published_at: '0000-00-00 00:00:00',
    starts_at: '0000-00-00 00:00:00',
    ends_at: '0000-00-00 00:00:00',
  },
};

export const searchResultPost = {
  type: 'POST',
  post: {
    id: postMock.id,
    name: postMock.headline,
    image: {
      provider: 'RAW',
      resource: 'http://localhost/resource.jpg',
    },
    top_of_the_list: false,
    highlight: false,
    published_at: '0000-00-00 00:00:00',
    short_description: postMock.headline,
  },
};

export const searchResults = [searchResultExhibitor, searchResultProduct, searchResultEvent, searchResultPost];

export const mappedSearchResults = () => {
  let entities: { [id: string]: any } = {};

  searchResults.forEach((entry, index) => {
    entities = {
      ...entities,
      [index + 1]: entry,
    };
  });

  return entities;
};

export const mappedSearchIds = () => Object.keys(mappedSearchResults());
